<template>
    <div class="container" style="min-width:2400px">
        <section class="">
            <div class="path">
                <span class="title">品牌</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(1,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=1;typeName='品牌'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="brandList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,1)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,1)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="品牌" prop="name"></el-table-column>
                    <el-table-column label="状态">
                         <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,1,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">品名</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(2,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=2;typeName='品名'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="breedList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,2)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,2)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="品名" prop="name"></el-table-column>
                    <el-table-column label="状态">
                         <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,2,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">等级</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(3,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=3;typeName='等级'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="gradeList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,3)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,3)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="等级" prop="name"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,3,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">属性</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(4,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=4;typeName='属性'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="attributeList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,4)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,4)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="等级" prop="name"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,4,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">选色</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(5,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=5;typeName='选色'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="colorList" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,5)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,5)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="等级" prop="name"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,5,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <section>
            <div class="path">
                <span class="title">销售品名</span>
                <div class="">
                    <i class="el-icon-refresh" @click="getList(6,1)"></i>
                    <el-button type="danger" @click="centerDialogVisible=!centerDialogVisible;type=2;which=6;typeName='销售品名'" size="mini">新增</el-button>
                </div>
            </div>
            <div class="table_path">
                <el-table :data="salesBreed" style="width: 100%" height="100%" size="mini" header-cell-class-name="list_table_th text-center">
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="icon_wrap">
                                <i class="operation_edit" @click="edit(scope.row.id,6)" title="修改"></i>
                                <i class="operation_delete" @click="del(scope.row.id,6)" title="删除"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售品名" prop="name"></el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.status==1?'setBaseBtnStatus':'setBaseBtnStatusProhibit'" @click="changeStatus(scope.row.id,6,scope.row.status)">{{scope.row.status_label}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </section>
        <el-dialog v-dialog-drag :title=" type == 2 ? '新增'+ typeName : '修改'+ typeName" :visible.sync="centerDialogVisible" width="400px"  class="eldialog eldialogOneLabel" :model="false">
            <el-form @submit.native.prevent>
                <el-form-item :label="typeName" prop="name" >
                    <el-input v-model="data.name" @keyup.enter.native="add" placeholder="请输入名称"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="add">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .container{ min-width: 2400px;
        padding:20px; display: flex; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        & > section{
            display: flex; flex-direction: column;
            & + section{ margin-left: 60px; }
        }
        .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #155BD4; padding-left: 12px;
            }
        }
        .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 340px; padding: 8px 10px;overflow: hidden;  }

    }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
</style>
<script>
    export default {
        data(){
            return{
                which:1,//1.品牌 2.品名 3.等级 4.属性 5.选色 6.销售品名
                type:2,//2.新增 3.修改
                typeName:"",
                data:{
                    name:"",
                    id:""
                },
                brandList:[],
                breedList:[],
                gradeList:[],
                attributeList:[],
                colorList:[],
                salesBreed:[],
                centerDialogVisible:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
            }
        },
        created(){
            this.getList(1)
            this.getList(2)
            this.getList(3)
            this.getList(4)
            this.getList(5)
            this.getList(6)
        },
        methods:{
            ceshi(){

            },
            changeStatus(id,type,status){
                let url="";
                this.which=type;
                if(type==1){
                    url="/erp/brand.status";
                }else if(type==2){
                    url="/erp/breed.status";
                }else if(type==3){
                    url="/erp/grade.status";
                }else if(type==4){
                    url="/erp/attribute.status";
                }else if(type==5){
                    url="/erp/color.status";
                }else if(type==6){
                    url="/erp/sales.breed.status";
                }
                if(status==1){
                    status=0
                }else{
                    status=1
                }
                this.postFunc(url,{id:id,status:status},()=>{
                    this.tip("修改成功","success")
                    this.getList(this.which)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            edit(id,type){
                let list=null;
                this.type = 3;
                this.which=type;
                if(this.which==1){
                    list=JSON.parse(JSON.stringify(this.brandList));
                    this.typeName="品牌";
                }else if(this.which==2){
                    list=JSON.parse(JSON.stringify(this.breedList));
                    this.typeName="品名";
                }else if(this.which==3){
                    list=JSON.parse(JSON.stringify(this.gradeList));
                    this.typeName="等级";
                }else if(this.which==4){
                    list=JSON.parse(JSON.stringify(this.attributeList));
                    this.typeName="属性";
                }else if(this.which==5){
                    list=JSON.parse(JSON.stringify(this.colorList));
                    this.typeName="选色";
                }else if(this.which==6){
                    list=JSON.parse(JSON.stringify(this.salesBreed));
                    this.typeName="销售品名";
                }
                list.forEach(item=>{
                    if(item.id==id){
                        this.data=item;
                    }
                })
                this.centerDialogVisible=true;
            },
            del(id,type){
                let url="";
                if(type==1){
                    url="/erp/brand.delete";
                }else if(type==2){
                    url="/erp/breed.delete";
                }else if(type==3){
                    url="/erp/grade.delete";
                }else if(type==4){
                    url="/erp/attribute.delete";
                }else if(type==5){
                    url="/erp/color.delete";
                }else if(type==6){
                    url="/erp/sales.breed.delete";
                }
                 this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc(url,{id:id},()=>{
                        this.getList(type)
                        this.tip("删除成功","success")
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(type = 1,showMessage){
                let url="";
                if(type==1){
                    url="/erp/brand.list";
                }else if(type==2){
                    url="/erp/breed.list";
                }else if(type==3){
                    url="/erp/grade.list";
                }else if(type==4){
                    url="/erp/attribute.list";
                }else if(type==5){
                    url="/erp/color.list";
                }else if(type==6){
                    url="/erp/sales.breed.list";
                }
                this.postFunc(url,{},res=>{
                    if(type==1){
                        this.brandList=res.data.data;
                    }else if(type==2){
                        this.breedList=res.data.data;
                    }else if(type==3){
                        this.gradeList=res.data.data;
                    }else if(type==4){
                        this.attributeList=res.data.data;
                    }else if(type==5){
                        this.colorList=res.data.data;
                    }else if(type==6){
                        this.salesBreed=res.data.data;
                    }
                    if(showMessage){
                        this.tip("刷新成功","success")
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            add(){
                let url="";
                if(this.which==1&&this.type==2){
                    url="/erp/brand.create";
                }else if(this.which==1&&this.type==3){
                    url="/erp/brand.update";
                }else if(this.which==2&&this.type==2){
                    url="/erp/breed.create";
                }else if(this.which==2&&this.type==3){
                    url="/erp/breed.update";
                }else if(this.which==3&&this.type==2){
                    url="/erp/grade.create";
                }else if(this.which==3&&this.type==3){
                    url="/erp/grade.update";
                }else if(this.which==4&&this.type==2){
                    url="/erp/attribute.create";
                }else if(this.which==4&&this.type==3){
                    url="/erp/attribute.update";
                }else if(this.which==5&&this.type==2){
                    url="/erp/color.create";
                }else if(this.which==5&&this.type==3){
                    url="/erp/color.update";
                }else if(this.which==6&&this.type==2){
                    url="/erp/sales.breed.create";
                }else if(this.which==6&&this.type==3){
                    url="/erp/sales.breed.update";
                }
                this.postFunc(url,this.data,()=>{
                    this.centerDialogVisible=false;
                    if(this.type==2){
                        this.tip("添加成功","success")
                    }else{
                        this.tip("修改成功","success")
                    }
                    this.getList(this.which)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        watch:{
            centerDialogVisible:function(val){
                if(!val){
                    this.data = this.resetJson(this.data)
                }
            }
        }
    }
</script>
